import { Component, Vue } from "vue-property-decorator";
import { DgLayout, DgSeparator, DgOnboardingBox } from "@dasgate/uikit";
import { OnboardingHeader } from "./_components/Header";

@Component({ components: { OnboardingHeader, DgLayout, DgSeparator, DgOnboardingBox } })
export default class OnBoardingPage extends Vue {}
